import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Estado } from 'src/app/model/estado.model';
import { RecuperacaoCredito } from 'src/app/model/recuperacao-credito.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RecuperacaoCreditoService } from './recuperacao-credito.service';


@Component({
    selector: 'app-recuperacao-credito-pesquisa',
    templateUrl: './recuperacao-credito-pesquisa.component.html',
    styleUrls: ['./recuperacao-credito-pesquisa.component.scss'],
    standalone: false
})
export class RecuperacaoCreditoPesquisaComponent implements OnInit {

  private pesquisaForm: UntypedFormGroup;
  private pesquisado = false; // usado no html
  public esconderPesquisa = true;
  private podeEscolherAgente = false;  // usado no html
  private podeEnviarRecCredito = false; // usado no html
  private ehAgenteFinanceiro = false;
  private valoresPesquisaForm: any;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private estados: Estado[] = [];
  private cnpjUsuario: string;
  private recuperacoesCredito: RecuperacaoCredito[];
  private atributosPaginacaoComponenteListagem: EntityPagedResult<RecuperacaoCredito>;
  private opcoesPaginacao: number[];
  private parametrosPesquisa:any = {};
  private totalObjetosRetornados: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: RecuperacaoCreditoService,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private fileUtils:FileUtilsService) {

      this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
      this.estados = this.activatedRoute.snapshot.data['dominios'].estadosRecuperacaoCredito;
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
      this.buscar(false, true)
  }

  ngOnInit() {
    this.valoresPesquisaForm = undefined;
    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario ? usuario.cnpj : null;
    });

    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.pesquisaForm = this.formBuilder.group({
      agenteFinanceiro: null,
      idRecuperacao: ['', [Validators.pattern(/^[0-9]+$/)]],
      idCobranca: ['', [Validators.pattern(/^[0-9]+$/)]],
      idProtocoloArquivo: ['', [Validators.pattern(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/), Validators.minLength(1), Validators.maxLength(36)]],
      estado:  null,
      idExternoOperacao: ['', [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
      sistema: null,
      contrato: ['', [Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
      dataEnvioInicio: null,
      dataEnvioFim: null
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeEnviarRecCredito = resp && resp[ROLE_AGENTE_ENVIO];
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];
      this.construirFormulario();
    });
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaRecuperacaoCreditoForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

    let agenteDefault: AgenteFinanceiro;
    if (this.podeEscolherAgente) {
        agenteDefault = this.valoresPesquisaForm.agenteFinanceiro ?
            this.agentesFinanceiros.filter(agente => agente.id === this.valoresPesquisaForm.agenteFinanceiro.id)[0]
            : null;
    } else {
        agenteDefault = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
        this.pesquisaForm.get('agenteFinanceiro').disable();
    };

    this.pesquisaForm.patchValue({
      agenteFinanceiro: agenteDefault,
      nomeJanela: this.valoresPesquisaForm.nomeJanela ? new Date(this.valoresPesquisaForm.nomeJanela) : null,
      idProtocoloArquivo: this.valoresPesquisaForm.idProtocoloArquivo ? this.valoresPesquisaForm.idProtocoloArquivo : null,
      estado: this.valoresPesquisaForm.estado ? this.estados.filter(i => i.id === this.valoresPesquisaForm.estado.id)[0] : null,
      sistema: this.valoresPesquisaForm.sistema ? this.valoresPesquisaForm.sistema : null,
      idExternoOperacao: this.valoresPesquisaForm.idExternoOperacao ? this.valoresPesquisaForm.idExternoOperacao : null,
      contrato: this.valoresPesquisaForm.contrato ? this.valoresPesquisaForm.contrato: null,
      dataEnvioInicio: this.valoresPesquisaForm.dataEnvioInicio ? this.valoresPesquisaForm.dataEnvioInicio : null,
      dataEnvioFim: this.valoresPesquisaForm.dataEnvioFim ? this.valoresPesquisaForm.dataEnvioFim : null
    });

    this.controlaCamposDesabilitados(this.valoresPesquisaForm);

    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.controlaCamposDesabilitados(novosValores);
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaRecuperacaoCreditoForm', JSON.stringify(this.valoresPesquisaForm));

    });
  }

  private controlaCamposDesabilitados(novosValores) {
    if (novosValores.sistema == 'CL') {
      if (!this.pesquisaForm.get('contrato').disabled) {
        if (this.pesquisaForm.get('contrato').value != '') {
          this.pesquisaForm.get('contrato').setValue('');
        }
        this.pesquisaForm.get('contrato').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('contrato').disabled) {
        this.pesquisaForm.get('contrato').enable();
      }
    }

    if (novosValores.sistema == '89' || novosValores.sistema == '15') {
      if (!this.pesquisaForm.get('idExternoOperacao').disabled) {
        if (this.pesquisaForm.get('idExternoOperacao').value != '') {
          this.pesquisaForm.get('idExternoOperacao').setValue('');
        }
        this.pesquisaForm.get('idExternoOperacao').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('idExternoOperacao').disabled) {
        this.pesquisaForm.get('idExternoOperacao').enable();
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedResult<RecuperacaoCredito>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;
    const params: any = {};

    const agenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    if (agenteFinanceiro) {
        params.cnpjAgenteFinanceiro = agenteFinanceiro.cnpj;
    }

    const sistema = this.pesquisaForm.get('sistema').value;
    if (sistema) {
      params.sistema = sistema;
    }

    const idRecuperacao = this.pesquisaForm.get('idRecuperacao').value;
    if (idRecuperacao) {
      params.idRecuperacaoCredito = idRecuperacao.trim();
    }

    const idCobranca = this.pesquisaForm.get('idCobranca').value;
    if (idCobranca) {
      params.idCobranca = idCobranca.trim();
    }

    const idExternoOperacao = this.pesquisaForm.get('idExternoOperacao').value;
    if (idExternoOperacao && idExternoOperacao.trim()) {
      params.idExternoOperacao = idExternoOperacao.trim();
    }

    const dataEnvioInicio = this.pesquisaForm.get('dataEnvioInicio').value;
    if (dataEnvioInicio) {
      params.dataEnvioInicio = this.datePipe.transform(dataEnvioInicio, 'yyyyMMdd');
    }

    const dataEnvioFim = this.pesquisaForm.get('dataEnvioFim').value;
    if (dataEnvioFim) {
      params.dataEnvioFim = this.datePipe.transform(dataEnvioFim, 'yyyyMMdd');
    }

    const contrato = this.pesquisaForm.get('contrato').value;
    if (contrato && contrato.trim()) {
      params.contrato = contrato.trim();
    }

    const estado: Estado = this.pesquisaForm.get('estado').value;
    if (estado) {
      params.idEstado = Number(estado.id);
    }

    const idProtocoloArquivo = this.pesquisaForm.get('idProtocoloArquivo').value;
    if(idProtocoloArquivo && idProtocoloArquivo.trim()){
      params.idProtocoloArquivo = idProtocoloArquivo.trim();
    }

    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));

    if(voltarPagina1){
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.recuperacoesCredito, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.service.getRecuperacoesCredito(params)
      .subscribe(response => {
        this.recuperacoesCredito = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.esconderPesquisa = false;
        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.recuperacoesCredito, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }

      });
  }

  compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }

  limpar() {
    this.pesquisado = false;
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.reset({agenteFinanceiro: this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0]});
    } else {
      this.pesquisaForm.reset();
    }
    this.recuperacoesCredito = [];
  }

  public exportarRecuperacoes(): string {
    let todasRecuperacoesCredito;
    let csv =` ID; AGENTE FINANCEIRO; ID. OPERAÇÃO; ID. EXT. OPERAÇÃO; SIST./CONTRATO; DATA ENVIO; DATA RECUP; DATA PGTO. RECUP.; VAL. RECUP.; VAL DEVIDO; MULTA; REVERSAO DE HONRA; VAL. HONRADO A RECUP. ANTES; VAL. HONRADO A RECUP. DEPOIS; ESTADO; ESTORNO MANUAL; CESTA-NUMERO\n`;

    this.loadingService.bloqueiaTela();
      this.service.getRecuperacoesCredito(this.parametrosPesquisa).subscribe(response=>{
        let tmp:string = "";

        (todasRecuperacoesCredito = response ? response.resultados : undefined) &&
        todasRecuperacoesCredito.forEach(recuperacao =>{
          tmp += `${recuperacao.id};${Utils.nomeAgentePorCNPJ(recuperacao.cnpjAgenteFinanceiro,this.agentesFinanceiros)};${this.normalizaZerosAEsquerda(recuperacao.idOperacao)};${this.normalizaZerosAEsquerda(recuperacao.idOperacaoExterno)};${ recuperacao.contratoRepasse ? recuperacao.sistemaRepasse + '/' + recuperacao.contratoRepasse : ''};${this.datePipe.transform(recuperacao.dataEnvio,'dd/MM/yyyy HH:mm')};${this.datePipe.transform(recuperacao.dataRecuperacao,'dd/MM/yyyy')};${this.datePipe.transform(recuperacao.dataPagamentoCobranca,'dd/MM/yyyy')};${Number(recuperacao.valorRecuperacao).toLocaleString('pt-BR', { minimumFractionDigits: 2 })};${Number(recuperacao.valorDevidoAoFgiPeac).toLocaleString('pt-BR', { minimumFractionDigits: 2 })};${recuperacao.temMulta == "true" ? "SIM" : "NÃO"};${recuperacao.reversaoHonra == "true" ? "SIM" : "NÃO"};${Number(recuperacao.valorHonradoARecuperarAntes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })};${Number(recuperacao.valorHonradoARecuperarDepois).toLocaleString('pt-BR', { minimumFractionDigits: 2 })};${recuperacao.estado.nomeEstado};${recuperacao.estornoManual === 'NAO' ? 'NÃO' : recuperacao.estornoManual || ''};${recuperacao.cestaNumero || ''}\n`;
        });
        this.loadingService.liberaTela();
        csv += tmp;
        this.exportar('RECUPERACOES_CREDITO_CSV.csv',csv);
      });

     return csv;
  }

  private exportar(nomeArquivo:string , conteudoCsv:any): void{
    this.fileUtils.exportarArquivo(nomeArquivo, "\ufeff"+conteudoCsv, FileUtilsService.TEXT_CSV);
  }

  private normalizaZerosAEsquerda(linha:string){
    return Utils.formataZerosAEsquerda(linha);
  }
}
